import { Tag, Tooltip } from "antd";
import { countries } from 'countries-list'
import { getTagColor } from "../../../../../../../helpers/user/tagColor";

export const itemsConfig = (t) => [
  {
    className: 'pr-lg',
    label: t('Operating Countries'),
    render: (data) => (data?.operatingCountries || []).length ? (data?.operatingCountries || []).map((c) => {
      const _c = countries[c];
      if (_c) {
        return (
          <Tooltip title={t(_c.name)} key={c}>
            <img alt={c} src={`https://flagcdn.com/w80/${c.toLowerCase()}.png`} />
            {/* <span style={{ fontSize: 20 }}>
              {_c.emoji}
            </span> */}
          </Tooltip>
        );
      }

      return null;
    }) : '--'
  },
  {
    className: 'px-lg',
    label: t('Commodities'),
    render: (data, options) => (data?.commodities || []).length ? (data?.commodities || []).map((v) => {
      const mineral = options.minerals.find((o) => o.value === v);

      if (mineral) {
        const color = getTagColor(v);
        return <Tag key={v} color={color} > {mineral.label}</Tag>
      }

      return null;
    }) : '--'
  },
  {
    className: 'px-lg',
    label: t('Active Investments'),
    render: (data) => <span>{data?.activeInvestments || '--'}</span>
  },
  {
    className: 'px-lg',
    label: t('Active Mines'),
    render: (data) => <span>{data?.activeMines || '--'}</span>
  },
  {
    className: 'pl-lg',
    label: t('Workers Benefiting'),
    render: (data) => <span>{data?.workersBenefiting || '--'}</span>
  },
]

